import { render, staticRenderFns } from "./CreateSubMenuModal.vue?vue&type=template&id=2c3502a1&scoped=true"
import script from "./CreateSubMenuModal.vue?vue&type=script&lang=js"
export * from "./CreateSubMenuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3502a1",
  null
  
)

export default component.exports